<template>
	<div id="data-requests-wrapper">
		<row>
			<div class="page-heading">
				<h1>Data Requests</h1>
				<breadcrumb :items="breadcrumb_items" />
			</div>
		</row>
		<row class="tab-row">
			<p-tab-menu v-model:activeIndex="active" :model="tabs">
				<template #item="{ label, item }">
					<template v-if="item.route">
						<div class="account-tab">
							<router-link :to="`${item.route}`">
								<div class="tab-label">
									{{ label }}
								</div>
							</router-link>
						</div>
					</template>
				</template>
			</p-tab-menu>
		</row>
		<row class="data-content">
			<div class="top-fade" />
			<router-view>
				<template #default="{ Component, route }">
					<transition name="drop-fade" mode="out-in">
						<component :is="Component" />
					</transition>
				</template>
			</router-view>
		</row>
	</div>
</template>

<script lang="ts">
import pTabMenu from 'primevue/tabmenu';
import pMenu from 'primevue/menu';
import { useSessionStore } from '@/stores/session';

export default {
	name: 'AccountManagerWorkstationWrapper',
	components: {
		pTabMenu,
		pMenu,
	},
	setup() {
		return {
			sessionStore: useSessionStore(),
		};
	},
	data() {
		return {
			active_tab: 0,
			active: 0,
			tabs: [
				{
					label: 'Request Statuses',
					route: '/data-requests/statuses',
					ref: 'statuses',
				},
				{
					label: 'Billing History',
					route: '/data-requests/billing-history',
					ref: 'billing-history',
				},
				{
					label: 'Leads By Account ID',
					route: 'leads-by-account-id',
					ref: 'leads-by-account-id',
				},
				{
					label: 'Archived Leads Lookup',
					route: 'archived-leads',
					ref: 'archived-leads',
				}
			],
			breadcrumb_items: [],
		};
	},
	computed: {},
	beforeMount() {
		const paths = this.$router.currentRoute.value.fullPath.split('/').filter((p) => {
			if (p) return p;
		});

		if (paths.length === 1) {
			this.$router.push('/data-requests/statuses');
		}
	},
	async mounted() {
		this.breadcrumb_items.push({
			label: 'Data Requests',
			route: '/data-requests',
		});
	},
	methods: {
		transitionType(route) {
			return route.matched[route.matched.length - 1].meta.transition || 'drop-fade';
		},
	},
};
</script>

<style scoped lang="less">
#data-requests-wrapper {
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	position: relative;

	.row {
		flex: 0 0 auto;
	}

	.data-content {
		display: flex;
		flex: 1 0;
		flex-direction: column;
		overflow-y: hidden;

		.view-content {
			min-height: auto;
		}
	}

	.top-fade {
		background: linear-gradient(
			180deg,
			rgb(255 255 255 / 100%) 0%,
			rgb(255 255 255 / 100%) 30%,
			rgb(255 255 255 / 0%) 100%
		);
		height: 40px;
		position: absolute;
		width: 100%;
		z-index: 100;
	}
}

.page-heading {
	margin-bottom: -20px;
	padding: 40px;
}

.data-content {
	background: linear-gradient(
		180deg,
		rgb(255 255 255 / 100%) 0%,
		rgb(255 255 255 / 0%) 15%,
		rgb(255 255 255 / 0%) 100%
	);

	:deep(h1) {
		font-size: 1.75rem;
		margin-bottom: 1rem;
	}

	:deep(.page-heading) {
		margin-bottom: 1em;
	}

	:deep(.p-breadcrumb) {
		display: none;
	}
}
</style>

<style lang="less">
.account-submenu {
	width: 240px;

	a {
		align-items: center;
		color: var(--gray-50);
		display: flex;
		height: 40px;
		line-height: 40px;
		padding: 0 1.5em;

		&:hover {
			text-decoration: none;
		}
	}
}
</style>
